// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025-2026 Daragh Farrell

import { Link, useLocation } from 'react-router-dom';

export default function RegistrationPending() {
  const location = useLocation();
  const email = (location.state as { email?: string })?.email || '';

  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient-to-b from-brand-50 via-white to-white px-4 py-10">
      <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-md text-center">
        <div className="mb-4">
          <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center">
            <span className="text-2xl">⏳</span>
          </div>
        </div>
        <h1 className="text-2xl font-semibold text-brand-700 mb-2">
          Registration Submitted
        </h1>
        <p className="text-slate-600 mb-6">
          Your registration is pending admin approval. You will be able to sign in once an
          administrator approves your account.
        </p>
        {email && (
          <p className="text-sm text-slate-500 mb-6">
            We've sent a confirmation to <strong>{email}</strong>
          </p>
        )}
        <Link
          to="/login"
          className="inline-block px-4 py-2 bg-brand-600 text-white rounded-lg hover:bg-brand-700 transition"
        >
          Back to Sign In
        </Link>
      </div>
    </div>
  );
}
